export default class RecordingFee {
    id?: number;
    stateId?: number;
    countyId?: number;
    dispositionId?: number;
    indexTypeId?: number;
    invoiceId?: number;
    documentNumber?: string;
    page?: string;
    recordDate?: Date;
    recordingFeeAmount?: number;
    assignNumber?: string;
    assignDate?: Date;
    transmitNumber?: string;
    transmitDate?: Date;
    lessorName?: string;
    documentType?: string;
    reqNumber?: string;
    legalDescription?: string;
    pages?: number;

    // Not mapped to the schema
    indexTypeName?: string;
    invoiceNumber?: string;
    leaseNumber?: string;
}


// WEBPACK FOOTER //
// ./src/models/RecordingFee.ts